let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("koz3q")).then(() => parcelRequire('8Uq5E'));